module.exports = new __parcel__URL__("insight-object-view-panel-skeleton.tpl.b6b0e1b0.svg").toString();